import { render } from "./KPIs.vue?vue&type=template&id=0da9778c"
import script from "./KPIs.vue?vue&type=script&lang=js"
export * from "./KPIs.vue?vue&type=script&lang=js"

import exportComponent from "/builds/uf-manage/mobile/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__